export enum DatabookLanguage {
  EnglishUS = 2,
  SpanishLatinAmerica = 16,
  Japanese = 20
}
